import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Slide from '@material-ui/core/Slide';
import { deepOrange } from '@material-ui/core/colors';
import { useSelector } from 'react-redux';
import {
  Button,
  fade,
  Grid,
  makeStyles,
  Divider
} from '@material-ui/core';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },

});

const useStyles = makeStyles((theme) => ({
  containers: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  cardcontent: {
    padding: 40,
  },

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 350,
    marginTop: 15,
    backgroundColor: '#FFFFFF',
    padding: 5,

  },
  avatar: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',

  },
  buttonMarkAll: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    width: 150,
    borderRadius: 0,
  },

  avatar1: {
    backgroundColor: deepOrange[500],
    padding: '10px 12px',
    maxWidth: '40px', maxHeight: '50px', minWidth: '30px', minHeight: '30px',
  },
  avatar2: {
    backgroundColor: deepOrange[800],
  },
  buttonColor: {
    maxWidth: 150, maxHeight: 35, minWidth: 150, minHeight: 35,
    backgroundColor: deepOrange[500],
  },
  itemRow: {
    display: 'flex',
    width: '100%',
    marginTop: '20px'
  },
  itemLabel: {
    padding: '10px 0',
    marginRight: '20px'
  },
  boxItems: {
    border: '1px solid gray',
    position: 'relative',
    top: '-0.5em',
    marginLeft: '10px',
    display: 'inline',
    backgroundColor: '#FFF'
  },
  boxTitle: {
    position: 'relative',
    top: '-0.5em',
    marginLeft: '10px',
    display: 'inline',
    backgroundColor: '#FFF'
  },
  fullItemRow: {
    width: '100%'
  },
  itemLegend: {
    padding: '0.2em 0.5em',
    fontSize: '90%',
    textAlign: 'right',
  },
  divContainer: {
    border: '1px solid gray',
    marginBottom: '20px'
  },
  scheduleContainer: {
    padding: '20px'
  },
  divider: {
    backgroundColor: '#000'
  },
  scheduleDateContainer: {
    display: 'flex',
    width: '100%',
    marginTop: '10px'
  },
  dateLabel: {
    width: '20%',
    padding: '10px 0px'
  },
  datePickerUtil: {
    width: '50%'
  },
  keyboardPicker: {
    height: 'auto',
    padding: '5px 0px'
  },
  scheduleTimeContainer: {
    display: 'flex',
    marginBottom: '20px'
  }
})
);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),

  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    backgroundColor: "#252525",

  },
}))(MuiDialogActions);


const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),

    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #ced4da',
    fontSize: 16,
    width: 300,
    padding: '10px 12px',
    marginLeft: theme.spacing(.3),
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

export default function CustomizedDialogs({ modalShow, modalState, id }) {
  const classes = useStyles();

  //use variables to update
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [open, setOpen] = useState(modalShow);
  const [dataContentOneForNow, setDataContentOneForNow] = useState([]);
  const [dynamicPlaylists, setDynamicPlaylists] = useState([]);
  const [updateScheduleDate, setUpdateScheduleDate] = useState([]);
  const { user } = useSelector(state => state.userAuthentication);

  const [presentation, setPresentation] = useState('');

  const handleChange = (event) => {
    setPresentation(event.target.value);
  };

  const handleClose = () => {
    modalState(false);
  };

  return (
    <div >
      {/* <Button variant="outlined" color="primary" onClick={handleClickOpen}>Open dialog </Button> */}
      <Dialog
        disableBackdropClick={true}
        open={open}
        TransitionComponent={Transition}
        keepMounted
        // onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle className="dialog-header" id="customized-dialog-title">Schedule Presentation</DialogTitle>
        <DialogContent dividers>
          <Grid container item justify="center" lg={12} xs={12} md={12}>
            <Grid className={classes.itemRow}>
              <span className={classes.itemLabel}>Presentation</span>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={presentation}
                  label="Presentation"
                  onChange={handleChange}
                >
                  <MenuItem value={10}>Sample 1</MenuItem>
                  <MenuItem value={20}>Sample 2</MenuItem>
                  <MenuItem value={30}>Sample 3</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid className={classes.fullItemRow}>
              <FormGroup style={{ margin: '20px 0px' }}>
                <FormControlLabel control={<Checkbox />} label="Active All Day Every Day" />
              </FormGroup>
              <div className={classes.divContainer}>
                <div style={{ padding: '10px 15px' }}>
                  <span className={classes.itemLegend}>Event Date and Time</span>
                </div>
                <div className={classes.scheduleContainer}>
                  <div className={classes.scheduleTimeContainer}>
                    <div style={{ marginRight: '20px', padding: '10px 0px' }}>
                      <span>Event Time: </span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '80%' }}>
                      <FormControl fullWidth style={{ marginRight: '20px' }}>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={presentation}
                          label="Presentation"
                          onChange={handleChange}
                        >
                          <MenuItem value={10}>Sample 1</MenuItem>
                          <MenuItem value={20}>Sample 2</MenuItem>
                          <MenuItem value={30}>Sample 3</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={presentation}
                          label="Presentation"
                          onChange={handleChange}
                        >
                          <MenuItem value={10}>Sample 1</MenuItem>
                          <MenuItem value={20}>Sample 2</MenuItem>
                          <MenuItem value={30}>Sample 3</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                  <Divider className={classes.divider}></Divider>
                  <div className={classes.scheduleDateContainer}>
                    <div className={classes.dateLabel}>Event Date: </div>
                    <MuiPickersUtilsProvider className={classes.datePickerUtil} utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        value={startDate}
                        onChange={setStartDate}
                        className={classes.keyboardPicker}
                        format="yyyy/MM/dd"
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>
              <div className={classes.divContainer}>
                <div style={{ padding: '0px 20px' }}>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox />} label="Recurrence" />
                  </FormGroup>
                </div>
                <div className={classes.scheduleContainer}>
                  <div className={classes.scheduleTimeContainer}>
                    <div style={{ width: '100%' }}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="All Days" />
                      </FormGroup>
                    </div>
                    <div style={{ width: '100%' }}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Sunday" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Monday" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Tuesday" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Wednesday" />
                      </FormGroup>
                    </div>
                    <div style={{ width: '100%' }}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Thursday" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Friday" />
                      </FormGroup>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox />} label="Saturday" />
                      </FormGroup>
                    </div>
                  </div>
                  <Divider className={classes.divider}></Divider>
                  <div className={classes.scheduleDateContainer}>
                    <div className={classes.dateLabel}>Start Date: </div>
                    <MuiPickersUtilsProvider className={classes.datePickerUtil} utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        value={startDate}
                        onChange={setStartDate}
                        className={classes.keyboardPicker}
                        format="yyyy/MM/dd"
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className={classes.scheduleDateContainer}>
                    <div className={classes.dateLabel}>Event Date: </div>
                    <MuiPickersUtilsProvider className={classes.datePickerUtil} utils={DateFnsUtils}>
                      <KeyboardDateTimePicker
                        value={startDate}
                        onChange={setStartDate}
                        className={classes.keyboardPicker}
                        format="yyyy/MM/dd"
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions classname="dialog-action">
          <Button variant="contained" className={classes.buttonColor}>Submit</Button>
          <Button variant="contained" color="default" onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
